import { Button } from "../Button";
import IconKeyboardArrowLeft from "@servicetitan/hammer-icon/mdi/round/keyboard_arrow_left.svg";
import IconKeyboardArrowRight from "@servicetitan/hammer-icon/mdi/round/keyboard_arrow_right.svg";
import styles from "./PaginationList.module.scss";
import cx from "classnames";
import { forwardRef } from "react";

type PaginationListProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  children: React.ReactNode;
  className?: string;
};

export const PaginationList = forwardRef<HTMLUListElement, PaginationListProps>(
  (props, ref) => {
    const { page, totalPages, children, onPageChange, className } = props;

    const paginationListClassName = cx(styles["pagination-list"], className);

    return (
      <>
        <Button
          appearance="ghost"
          icon={IconKeyboardArrowLeft}
          size="small"
          aria-label="Previous page"
          disabled={page === 1}
          onClick={() => {
            if (page > 1) {
              onPageChange?.(page - 1);
            }
          }}
        />
        <ul ref={ref} className={paginationListClassName}>
          {children}
        </ul>
        <Button
          appearance="ghost"
          icon={IconKeyboardArrowRight}
          size="small"
          aria-label="Next page"
          disabled={page === totalPages}
          onClick={() => {
            if (page < totalPages) {
              onPageChange?.(page + 1);
            }
          }}
        />
      </>
    );
  },
);

PaginationList.displayName = "PaginationList";
